import { render, staticRenderFns } from "./ReligionAccount.vue?vue&type=template&id=c46c66ca&scoped=true&"
import script from "./ReligionAccount.vue?vue&type=script&lang=js&"
export * from "./ReligionAccount.vue?vue&type=script&lang=js&"
import style0 from "./ReligionAccount.vue?vue&type=style&index=0&id=c46c66ca&prod&lang=css&"
import style1 from "./ReligionAccount.vue?vue&type=style&index=1&id=c46c66ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46c66ca",
  null
  
)

export default component.exports